import React from 'react';
import { useOfferContext } from '../../Offer';
import { ReactComponent as RetryVector } from 'icons/retry-vector.svg';
import { ReactComponent as BankTransfer } from 'icons/bank-transfer-grey.svg';

const RecurringInfo = () => {
  const { i18n, recurring } = useOfferContext();
  if (recurring === undefined) {
    return null;
  }
  const Icon = recurring ? RetryVector : BankTransfer;
  const labelMessageKey = recurring
    ? 'paymentOptions.recurringPayment.autoPay'
    : 'paymentOptions.recurringPayment.manualPay';

  return (
    <div className="ml-4 mr-[42px] flex items-center justify-center">
      <span className="mr-1">
        <Icon />
      </span>
      <span className="text-sm text-gray-700">{i18n.t(labelMessageKey)}</span>
    </div>
  );
};

export { RecurringInfo };
